import React, { useEffect } from "react";
import "./css/App.css";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  useLocation,
} from "react-router-dom";
// import onWebviewClose from './components/Button';
// import Notice from "./Notice";
import NotFound from "./components/NotFound";
import NoticeList from "./Notice/NoticeList";
import NoticeArticle from "./Notice/NoticeArticle";
import FaqList from "./Faq/FaqList";
import FaqArticle from "./Faq/FaqArticle";

const ThemeWatcher = () => {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const mode = params.get("mode");
    const isLight = mode && mode.toLowerCase() === "light";
    document.body.dataset.theme = isLight ? "light" : "dark";

    // back=false 일 때 html 배경색을 다르게 준다 (색상은 App.css의
    // --bg-color-noback; 현재는 임시값). faqConfig와 동일하게 "false"일 때만 false.
    const back = params.get("back");
    document.documentElement.dataset.back =
      back != null && back.toLowerCase() === "false" ? "false" : "true";
  }, [search]);
  return null;
};

const App = () => {
  return (
    <Router>
      <React.Fragment>
        <ThemeWatcher />
        <Switch>
          <Route exact={true} path={"/"} component={NoticeList} />
          <Route path={"/faq/articles/:id"} component={FaqArticle} />
          <Route path={"/faq"} component={FaqList} />
          <Route path={"/notices/:id"} component={NoticeArticle} />
          <Route path="*" component={NotFound} />
        </Switch>
      </React.Fragment>
    </Router>
  );
};

export default App;
